import React, { FC } from 'react';

type RideCardItemType = {
  label: string;
  segmentLocation: any;
  dataTestId?: string;
};

export const SendMessageRideCardItem: FC<RideCardItemType> = ({
  label,
  segmentLocation,
  dataTestId,
}) => {
  return (
    <div
      data-test-id={`${dataTestId}-send-message-ride-card-item`}
      className="send-message-rides__point"
    >
      <span className="point-index">{label}</span>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
          marginTop: '5px',
        }}
      >
        <div className="point-name">
          <p>{segmentLocation?.businessName}</p>
          <p>{segmentLocation?.name}</p>
        </div>
        <div className="point-address">
          <p>{segmentLocation?.address1}</p>
          <p>{segmentLocation?.state.value}</p>
          <p>{segmentLocation?.zipCode.value}</p>
        </div>
      </div>
    </div>
  );
};
